import type { TopContentSlotEntry } from '../types';

/** Normalize a brand name or pasted URL for `MarketplaceProfile.brands`. */
export function normalizeMarketplaceBrandName(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return '';
  return (
    trimmed.replace(/^https?:\/\//i, '').replace(/^www\./i, '').split(/[/?#]/)[0] || trimmed
  );
}

/** Append unique brand names (case-insensitive) to the worked-with list. */
export function mergeMarketplaceBrands(existing: string[], ...names: (string | undefined)[]): string[] {
  const next = [...existing];
  for (const name of names) {
    if (!name) continue;
    const normalized = normalizeMarketplaceBrandName(name);
    if (!normalized) continue;
    if (next.some((b) => b.toLowerCase() === normalized.toLowerCase())) continue;
    next.push(normalized);
  }
  return next;
}

/** Distinct `associatedBrand` values from top-content slots. */
export function associatedBrandsFromTopSlots(slots: (TopContentSlotEntry | null)[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const slot of slots) {
    const brand = slot?.associatedBrand?.trim();
    if (!brand) continue;
    const key = brand.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(brand);
  }
  return out;
}
